import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductDialogComponent } from '../../products/product-dialog/product-dialog.component';
import { CartService } from 'src/app/components/shared/services/cart.service';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { ConfigService } from 'src/app/components/shared/services/config.service';
import { CompanyService } from 'src/app/components/shared/services/company.service';
import { SwiperConfig } from '../../../shared/directive/swiper.directive';

@Component({
    selector: 'app-product-carousel',
    templateUrl: './product-carousel.component.html',
    styleUrls: ['./product-carousel.component.sass'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductCarouselComponent implements OnInit {
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  @Input('product') product: Array<any> = [];
  public config: SwiperConfig = {};
  contentLoaded = false;
  constructor(public configService:ConfigService,private dialog: MatDialog, private router: Router, private cartService: CartService, private productService: ProductService, public companyService:CompanyService) { }

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
    }, 3000);
  }
  ngAfterViewInit(){ 
    this.config = {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      // Swiper 4 breakpoints were max-width, Swiper 12's are min-width: same ranges re-expressed (GX-7106).
      breakpoints: {
        481: { slidesPerView: 2 },
        741: { slidesPerView: 3 },
        961: { slidesPerView: 4 },
        1281: { slidesPerView: 5 }
      }
    }
  }


  public openProductDialog(product){
    let dialogRef = this.dialog.open(ProductDialogComponent, {
        data: product,
        panelClass: 'product-dialog',
    });
    dialogRef.afterClosed().subscribe(product => {
      if(product){
        this.router.navigate(['/products', product.id, product.name]);
      }
    });
  }

   // Add to cart
   public addToCart(product: any,  quantity: number = 1) {
    this.cartService.addToCart(product,quantity);
  }

}



